var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"secondary-action-btn",attrs:{"width":"100%","height":"48px"},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('span',{class:_vm.text && 'pl-3',staticStyle:{"margin-right":"-1.3rem"}},[_vm._t("default")],2),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }